import { SqlExercise } from '../../types/sql';

export const examTechnicalExercises: SqlExercise[] = [
  {
    id: 1,
    level: 'EXAMEN TÉCNICO',
    title: 'Ejercicio 1: Listar Países de Clientes',
    description: 'Listar de manera descendente, los diferentes países de los clientes. Nombrar a la columna Países.',
    expectedColumns: ['Paises'],
    solution: `SELECT DISTINCT 
        country AS Paises
FROM    customers 
ORDER BY country DESC;`,
    difficulty: 'intermediate'
  },
  {
    id: 2,
    level: 'EXAMEN TÉCNICO',
    title: 'Ejercicio 2: Empleados sin Personas a Cargo',
    description: 'Mostrar número de empleado y nombre concatenado con el apellido, de los empleados que no tengan personas a cargo (reportsTo).\n\nComentarios adicionales:\n- El campo concatenado se deberá llamar NameEmployee\n- Se debe ordenar por número de empleado de menor a mayor.',
    expectedColumns: ['employeeNumber', 'NameEmployee'],
    solution: `SELECT 
         e.employeeNumber
        ,CONCAT(e.firstName, ' ', e.lastName) AS NameEmployee
FROM    employees e
WHERE NOT EXISTS (
          SELECT 
                 1
          FROM   employees sub
          WHERE  sub.reportsTo = e.employeeNumber
            )
ORDER BY e.employeeNumber ASC;`,
    difficulty: 'intermediate'
  },
  {
    id: 3,
    level: 'EXAMEN TÉCNICO',
    title: 'Ejercicio 3: Empleados por Oficina',
    description: 'Mostrar el total de empleados en las oficinas de San Francisco, NYC y Tokyo.\nAdemás mostrar la dirección de la oficina y, en un solo campo, estado y ciudad.\nAdicional, sólo mostrar los registros donde el total de empleados sea mayor a dos.\n\nNOTA: Los nombres de las columnas deben ser: direccion, estado_ciudad, cant_empleados.',
    expectedColumns: ['direccion', 'estado_ciudad', 'cant_empleados'],
    solution: `SELECT
         o.addressLine1 AS direccion
        ,CONCAT(o.state, ' - ', o.city) AS estado_ciudad
        ,COUNT(e.employeeNumber) AS cant_empleados
FROM        offices o
INNER JOIN  employees e ON e.officeCode = o.officeCode
WHERE   1=1
AND o.city IN ('San Francisco', 'NYC', 'Tokyo')
GROUP BY 
        o.addressLine1 
        ,o.state
        ,o.city
HAVING COUNT(e.employeeNumber) > 2;`,
    difficulty: 'advanced'
  },
  {
    id: 4,
    level: 'EXAMEN TÉCNICO',
    title: 'Ejercicio 4: Costo Total de Pedidos por Categoría (2004)',
    description: `Traer el costo total de los pedidos enviados cuya fecha de orden se haya generado en 2004.
Además, ese costo total se debe discriminar por la siguiente categorización:
- Si el productline es "Motorcycles", "Classic Cars" o "Vintage Cars" y el productScale es "1:18", es Category One.
- Si el productline es "Trains" o "Trucks and Buses" y el productScale es "1:50", es Category Two.
- Para el resto sería Category Three.

Sugerencias:
- Para identificar los pedidos enviados se debe filtrar en el campo status de la tabla orders la palabra "Shipped".
- La fecha de la orden se encuentra en el campo orderDate de la tabla orders
- El campo que contiene la nueva categorización se debe llamar Category
- El campo con el costo total se calcula multiplicando los campos quantityOrdered y priceEach de la tabla orderdetails. Además, dicho campo se debe llamar Grand_Total
- Ordenar por el costo total de manera descendente`,
    expectedColumns: ['Grand_Total', 'Category'],
    solution: `SELECT 
         SUM(od.quantityordered * od.priceeach) AS Grand_Total
        ,CASE 
            WHEN p.productline IN ('Motorcycles', 'Classic Cars', 'Vintage Cars') 
                 AND p.productscale = '1:18' THEN 'Category One'
            WHEN p.productLine IN ('Trains', 'Trucks and Buses') 
                 AND p.productscale = '1:50' THEN 'Category Two'
            ELSE 'Category Three'
        END as Category
FROM       orders o
INNER JOIN orderdetails od ON (o.ordernumber = od.ordernumber)
INNER JOIN products p ON (od.productcode = p.productcode)
WHERE 1=1
AND   o.status = 'Shipped'
AND   o.orderdate BETWEEN '2004-01-01' AND '2004-12-31'  
GROUP BY Category
ORDER BY Grand_Total DESC;`,
    difficulty: 'advanced'
  },
  {
    id: 5,
    level: 'EXAMEN TÉCNICO',
    title: 'Ejercicio 5: Top 10 Productos con Más Órdenes',
    description: 'Mostrar para los 10 productos con más órdenes, la cantidad de total de órdenes de esos productos y el precio total acumulado. Adicionalmente incluir el precio promedio, mínimo y máximo de sus órdenes.',
    expectedColumns: ['productCode', 'productName', 'total_ordenes', 'precio_total_acumulado', 'precio_promedio', 'precio_minimo', 'precio_maximo', 'rk'],
    solution: `WITH producto_stats AS (
    SELECT 
          p.productCode
         ,p.productName
         ,COUNT(DISTINCT od.orderNumber) AS total_ordenes
         ,ROUND(SUM(od.quantityOrdered * od.priceEach),2) AS precio_total_acumulado
         ,ROUND(AVG(od.priceEach),2) AS precio_promedio
         ,MIN(od.priceEach) AS precio_minimo
         ,MAX(od.priceEach) AS precio_maximo
    FROM products p
    INNER JOIN orderdetails od  ON (p.productCode = od.productCode)
    GROUP BY 
        p.productCode,
        p.productName
),
ranking AS (
    SELECT 
            productCode
           ,productName
           ,total_ordenes
           ,precio_total_acumulado
           ,precio_promedio
           ,precio_minimo
           ,precio_maximo
           ,RANK() OVER (ORDER BY total_ordenes DESC) AS rk
    FROM producto_stats
)
SELECT 
        productCode
       ,productName
       ,total_ordenes
       ,precio_total_acumulado
       ,precio_promedio
       ,precio_minimo
       ,precio_maximo
       ,rk
FROM ranking
WHERE rk <= 10
ORDER BY total_ordenes DESC;`,
    difficulty: 'advanced'
  },
  {
    id: 6,
    level: 'EXAMEN TÉCNICO',
    title: 'Ejercicio 6: Seleccionar Clientes que Comienzan con "AU"',
    description: 'Seleccionar de la tabla customers los registros que comiencen con "AU" en el nombre. Mostrar la cantidad total de registros que cumplen esta condición.',
    expectedColumns: ['cantidad_total'],
    solution: `SELECT 
    COUNT(1) AS cantidad_total
FROM customers
WHERE UPPER(customerName) LIKE 'AU%';`,
    difficulty: 'intermediate'
  }
];

